import React from "react";
import { Alert } from "antd";
import { ReactComponent as SuccessIcon } from "../assets/svg/icons/alert-success.svg";

const VALID_TYPES = ["success", "info", "warning", "error"];

const CommonAlert = ({
  type = "info",
  message,
  description,
  closable = true,
  onClose,
}) => {
  const safeType = VALID_TYPES.includes(type) ? type : "info";

  return (
    <div
      className="custom-alert-container"
      style={description ? { top: 130 } : {}}
    >
      <Alert
        type={safeType}
        message={message}
        description={description}
        closable={closable}
        onClose={onClose}
        showIcon
        icon={
          safeType === "success" ? <SuccessIcon className="tw-mt-1" /> : undefined
        }
      />
    </div>
  );
};

export default CommonAlert;
